import { ShopItemAdapter } from "../adapters/types";
import { z } from "zod";

import { ItemType } from "@/types/enums/item-type";
import { PackagePurchaseLineInput, PackageShopCartLine } from "@/types/shop";

const lineSchema = z.object({
  kind: z.literal("package"),
  quantity: z
    .number()
    .int()
    .min(1, "Quantity must be at least 1.")
    .max(500, "Maximum 500 packages per line."),
  unitPriceCents: z.number().int().positive("Package price is invalid."),
  expectedUnitPriceCents: z.number().int().positive().optional(),
  itemId: z.string().min(1, "Package is invalid."),
});

const validate = (line: PackageShopCartLine): string | null => {
  const result = lineSchema.safeParse(line);
  if (result.success) return null;
  return result.error.issues[0]?.message ?? "Package line is invalid.";
};

const serializeForCheckout = (
  line: PackageShopCartLine,
): PackagePurchaseLineInput => ({
  itemType: ItemType.PACKAGE,
  itemId: line.itemId,
  quantity: line.quantity,
  expectedUnitPriceCents: line.expectedUnitPriceCents ?? line.unitPriceCents,
});

const normalizeLine = (line: PackageShopCartLine): PackageShopCartLine => ({
  ...line,
  quantity: Math.min(500, Math.max(1, line.quantity)),
});

export const packageAdapter: ShopItemAdapter<
  PackageShopCartLine,
  PackagePurchaseLineInput
> = {
  type: ItemType.PACKAGE,
  validate,
  serializeForCheckout,
  normalizeLine,
};
